import React, { useState, useEffect, useContext } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import { format } from 'date-fns';
import LoadingContent from '../../componentes/loading/loading';

//---------COMPONENTES----------------------
import Header from '../../componentes/Header/index';
import Footer from '../../componentes/Footer/index';
import { Functions, SetFunctions } from '../../componentes/Functions';
import {Load_Bola} from '../../componentes/loading/Func_Load';

import { ModalCotacao_PREVIEW } from '../../componentes/Modal/ModalCota_PREVIEW';
import { ListaEventosPlaca } from '../../componentes/ListarPesquisas/ListaEventoPlaca';
import { PesquisaPlaca } from "../../componentes/Pesquisas/PesquisaPlaca";

// ---------APIS---------------------------
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import api from '../../services/api';
import { Api_Clientes } from '../../services/FiltrosApi/clienteApi';

// --------VISTORIA----------
import { Geolocalizacao } from '../../componentes/Cadastro/Geolocalizacao';
import { CondutorEvento } from '../../componentes/Cadastro/CondutorEvento';
import { CameraSinistro } from '../../componentes/Cadastro/CameraSinistro';
import {NarracaoEvento} from '../../componentes/Cadastro/NarracaoEvento';
import { ExibirArquivosS3 } from '../../componentes/Cadastro/ExibirArquivosS3';
import { CameraSelfie } from '../../componentes/Cadastro/CameraSelfie';
import { Add_Arquivos } from '../../componentes/Cadastro/Add_Arquivos';

import { BotaoAlertVistoria } from '../../componentes/alerte/botaoAlertVistoria';
import { BotaoAlertCodutor } from '../../componentes/alerte/botaoAlertCodutor';
import { CotacaoResumo } from '../Cotacao/CotacaoResumo';

// ------------------------------------------
function Vistoria() {
    const { state, dispatch } = useContext(Context);
    const { veiculo } = state.veiculo;
    const { evento } = state.evento;
    const { cliente } = state.cliente;
    const { parametroInit, listaPesquisa, displayModal } = state.parametros;
    const {
        loading, 
    } = parametroInit;
    // ---------------------------------
    const [buscandoDadosPlaca, setBuscandoDadosPlaca] = useState(false);
    const [sucessoBuscaPlaca, setSucessoBuscaPlaca] = useState(false);
    const [dadosDivergentes, setDadosDivergentes] = useState(false);
    const [dadosCompletos, setdadosCompletos] = useState(false);
    const [ConfirmadoPlaca, setConfirmarDados] = useState(false);
    const [onOk, setOnOk] = useState(false);
    const [mostrarDados, setmostrarDados] = useState(false);

    const [erroBuscaPlaca, setErroBuscaPlaca] = useState('');
    const [situacaoDivergente, setSituacaoDivergente] = useState(false); 
    const [maioresScoresFipe, setmaioresScoresFipe] = useState([]);
    const [valorFipeNumerico, setValorFipeNumerico] = useState(null);

    const [erroNumero, setErroNumero] = useState('');
    const [valorMensalCotac, setvalorMensal] = useState('');

    const [narracaoDigitada, setNarracaoDigitada] = useState('');
    const [ImgPosition, setarrayImgPosition] = useState([]);
    const S3_BASE_URL = 'https://rbento-web.s3.us-east-1.amazonaws.com/';
    
    const [mostrarCamera, setMostrarCamera] = useState(false);
    const [activePanel, setActivePanel] = useState('');
    const [ModalCondutor, setModalCondutor] = useState(false);
    const [condutorOutro, setOutroCondutor] = useState(false);
    const [CondutorAssociado, setCondutorAssociado] = useState(false);
    const [boasVindas, setBoasVindas] = useState(false);
    const [cotacaoAceita, setCotacaoAceita] = useState(false);
    const [cotacaoExistente, setCotacaoExistente] = useState(false);
    const [tipoVistoria, setTipoVistoria] = useState('');
    const [dadosFipeRecebidos, setDadosFipeRecebidos] = useState(null);
    const [arqVistoria, setArqVistoria] = useState([]);

    const [selfieArquivo, setselfieArquivo] = useState('');
    const [selfieParaDecisao, setSelfieParaDecisao] = useState('');
    const [abrirCameraRefazer, setAbrirCameraRefazer] = useState(false);
    const [refazendoSelfie, setRefazendoSelfie] = useState(false);

    const { EditarSelect} = Functions();
    const { PesqVistoriaPlaca, AtualizarIdEvento } = ApiEvento();
    const { AddPlaca, AddCotacao } = Api_Veiculos();
    const { SetParametroInit } = SetFunctions();
    const { AtualizarIdCliente } = Api_Clientes();
    const { SelectFile, AddArquivos } = Add_Arquivos();
    // Função para buscar a última selfie do cliente
    function buscarUltimaSelfieCliente() {
        const clienteNaLista = cliente.id_Cliente
            ? listaPesquisa.listaCliente.find(item => item?._id === cliente.id_Cliente)
            : null;
        const clienteNoVeiculo =
            listaPesquisa.listaVeiculo.find(item => item?._id === veiculo.id_Veiculo)?.id_Cliente ||
            listaPesquisa.listaVeiculo[0]?.id_Cliente;
        const clienteSelecionado = clienteNaLista || clienteNoVeiculo;
        const arquivos = clienteSelecionado?.arquivos || cliente.selfie || [];

        return Array.isArray(arquivos)
            ? arquivos.filter(arquivo => typeof arquivo === 'string' && arquivo.toLowerCase().includes('selfie')).pop() || ''
            : '';
    };

    // -----------------------------

    useEffect(() => {
        dispatch({
            type: 'SET_Display',
            payload: {
                ...displayModal,
                eventoDisplay: false,
            }
        });
    }, []);
    // ---------------------------------
    
    useEffect(() => {
        if (listaPesquisa.listaEvento.length > 0) {
            const t = listaPesquisa.listaEvento[0];
            dispatch({
                type: 'set_Evento',
                payload: {
                    ...evento,
                    id_Evento: t._id,
                    nomeCliente: t?.id_Veiculo?.id_Cliente?.nome,
                    tipoEvento: t.tipoEvento,
                    dataEvento: t.dataEvento ? format(new Date(t.dataEvento), 'yyyy-MM-dd') : '',
                    status: t.status,
                    narracao: t.narracao,
                    arquivos: t?.arquivos.reverse(),

                    id_Condutor: t?.id_Condutor?._id,
                    nomeCondutor: t?.id_Condutor?.nome,
                }
            });
        };
    }, [listaPesquisa.listaEvento]);
    // ---------------------------------
    
    useEffect(() => {
        if (listaPesquisa.listaVeiculo.length > 0) {
            const t = listaPesquisa.listaVeiculo[0];
            dispatch({
                type: 'set_cliente',
                payload: {
                    ...cliente,
                    id_Cliente: t?.id_Cliente?._id,
                    nome: t?.id_Cliente?.nome,
                    cpfCnpj: t?.id_Cliente?.cpfCnpj,
                    celular: t?.id_Cliente?.foneCelular?.numeroCel,
                    selfie: t?.id_Cliente?.arquivos
                }
            });

            dispatch({
                type: 'set_veiculo',
                payload: {
                    ...veiculo,
                    id_Veiculo: t?._id,
                    id_ClienteVeiculo: t?.id_Cliente?._id || "",
                    tipo: t?.tipo,
                    placa: t?.placa,
                    modelo: t?.modelo,
                    anoMod: t?.anoMod,
                    cor: t?.cor,
                    marca: t?.marca,
                    valorFipe: t?.valorFipe,
                    situacao: t?.situacao,
                }
            });
        };
    }, [listaPesquisa.listaVeiculo, tipoVistoria]);
    
    // ---------------------------------
    // Verifica se o veículo já possui cotação salva
    useEffect(() => {
        if (!ConfirmadoPlaca || !veiculo.id_Veiculo) {
            setCotacaoExistente(false);
            return;
        }
        let ativo = true;
        api.get(`veiculo/cotacao/${veiculo.id_Veiculo}`)
            .then(res => {
                const registros = (res.data?.registros || []).filter(r => r.status !== 'E');
                if (ativo) setCotacaoExistente(!!res.data?._id && registros.length > 0);
            })
            .catch(() => { if (ativo) setCotacaoExistente(false); });
        return () => { ativo = false; };
    }, [ConfirmadoPlaca, veiculo.id_Veiculo]);

    // Cadastro com cotação já existente: pula condutor e boas-vindas
    const pularCadastro = tipoVistoria === 'vistoria_cadastro' && cotacaoExistente;

    useEffect(() => {
        if (pularCadastro) {
            setCotacaoAceita(true);
            setOutroCondutor(false);
            setCondutorAssociado(false);
            setModalCondutor(false);
            setBoasVindas(false);
        }
    }, [pularCadastro]);

    // ---------------------------------
    useEffect(() => {
        if (!ConfirmadoPlaca || !veiculo.placa) {
            setOutroCondutor(false);
            setModalCondutor(false);
            setTipoVistoria('');
            setCotacaoAceita(false);
            return;
        }

        // Sempre pergunta o tipo de vistoria após confirmar o veículo, mesmo com evento/cadastro existente
        if (!tipoVistoria) {
            if (!condutorOutro && activePanel === 'dados') setModalCondutor(true);
            return;
        }

        if (evento.id_Condutor && tipoVistoria === 'vistoria_evento') {
            setModalCondutor(false);
            return;
        }

        if (!condutorOutro && activePanel === 'dados' && !pularCadastro) {
            setModalCondutor(true);
        };
    }, [ConfirmadoPlaca, veiculo.placa, evento.id_Condutor, condutorOutro, activePanel, pularCadastro, tipoVistoria]);

    // ---------------------------------
    useEffect(() => {
        if (tipoVistoria === 'vistoria_cadastro' && !cotacaoExistente) {
           veiculo.id_ClienteVeiculo ? setCondutorAssociado(true) : setOutroCondutor(true);            
        }
    }, [tipoVistoria]);

    // ---------------------------------
    // Adesão no cadastro = 0,5% do valor FIPE
    useEffect(() => {
        if (tipoVistoria !== 'vistoria_cadastro') return;
        const fipe = parseFloat(veiculo.valorFipe);
        if (isNaN(fipe)) return;
        const adesao = Math.round(fipe * 0.005 * 100) / 100;
        if (parseFloat(veiculo.valorAdesao) !== adesao) {
            dispatch({ type: 'set_veiculo', payload: { ...veiculo, valorAdesao: adesao } });
        }
    }, [tipoVistoria, veiculo.valorFipe, veiculo.valorAdesao]);

    // ---------------------------------
    useEffect(() => {
        if (veiculo.placa) {
            setmostrarDados(true);
            PesqVistoriaPlaca(veiculo.placa);
        }
    }, [veiculo.placa]);
    
    // ---------------------------------

    const [primeiroNome, setPrimeiroNome] = useState('');

    useEffect(() => {
    //   pegar o primeiro nome do cliente
      const nomes = cliente.nome ? cliente.nome.split(' ') : [];
      const primeiroNome = nomes.length > 0 ? nomes[0] : ''; 
      setPrimeiroNome(primeiroNome);
       
    }, [cliente.nome])

    // ---------------------------------
    const [abrirCamera, setabrirCamera] = useState(false);
    const [selfieCapturada, setselfieCapturada] = useState(null);
    const [confirmarImagemSelfie, setConfirmarImagemSelfie] = useState(false);

    // selfieCapturada: // Função para converter base64 em File. usando fetch e blob.
    useEffect(() => {
        const converterBase64ParaFile = async (base64String, fileName) => {
            const response = await fetch(base64String);
            const blob = await response.blob();
            return new File([blob], fileName, { type: 'image/png' });
        };

        if (confirmarImagemSelfie && selfieCapturada) {
            let nomeFile = `selfie_${veiculo.placa}.png`;
            converterBase64ParaFile(selfieCapturada, nomeFile.replace(/ /g, "_"))
            .then((file) => {
                // Aqui você pode enviar o arquivo para o servidor 
                if(tipoVistoria === 'vistoria_cadastro') {
                    AtualizarIdCliente({ arquivosConvertidos: [file] });
                } else {
                    AtualizarIdEvento({ tipoFile: "selfie", arquivosConvertidos: [file] });
                }
                
                // Resetar estados
                setConfirmarImagemSelfie(false);
                setselfieCapturada(null);
            })
            .catch((error) => {
                console.error('Erro ao converter a selfie:', error);
            });
        }
    }, [confirmarImagemSelfie, selfieCapturada]);
    // --------------------------------

    useEffect(() => {
        const cadastro = tipoVistoria === 'vistoria_cadastro';

        // Antes de escolher o tipo de vistoria, fica no painel que exibe a escolha
        if (ConfirmadoPlaca && !tipoVistoria) {
            setActivePanel('dados');
            return;
        }

        // No cadastro, a selfie só é liberada após o cliente concordar com a cotação
        if (cadastro && !cotacaoAceita) {
            if (ConfirmadoPlaca) setActivePanel('dados');
            return;
        }

        if (abrirCameraRefazer && ((cadastro && cotacaoAceita) || (!cadastro && evento.id_Condutor))) {
            setActivePanel('selfie');
            setMostrarCamera(true);
            setAbrirCameraRefazer(false);
            return;
        }

        if (ConfirmadoPlaca && !evento.id_Condutor && !selfieCapturada && !selfieArquivo && !(cadastro && cotacaoAceita)) {
            setActivePanel('dados');
            return;
        }

        if ((evento.id_Evento || veiculo.id_ClienteVeiculo) && !selfieArquivo && !selfieCapturada) {
            setActivePanel('selfie');
            return;
        }

        if (tipoVistoria === 'vistoria_cadastro' && selfieArquivo) {
            setMostrarCamera(false);
            setActivePanel('vistoria');
            return;
        }

        if (evento.id_Evento && selfieArquivo && !evento.narracao) {
            setActivePanel('narracao');
            return;
        }

        if ((evento.narracao || tipoVistoria === 'vistoria_cadastro') && arqVistoria.length === 0) {
            setActivePanel('vistoria');
            return;
        }

        if (arqVistoria.length > 0) {
            setActivePanel('painel_arquivos');
        }
    }, [ConfirmadoPlaca, evento.dataEvento, evento.id_Condutor, cliente.id_Cliente, evento.id_Evento, selfieArquivo, selfieCapturada, evento.narracao, arqVistoria, tipoVistoria, cotacaoAceita, veiculo.id_ClienteVeiculo, abrirCameraRefazer]);
    // --------------------------------

    // Evento: a selfie é a do próprio evento (sempre uma nova selfie por evento)
    useEffect(() => {
        if (tipoVistoria !== 'vistoria_evento') return;
        const selfieEvento = evento.id_Evento
            ? (evento.arquivos || []).filter(arquivo => arquivo.includes('selfie')).pop()
            : '';
        setselfieArquivo(selfieEvento || '');
    }, [tipoVistoria, evento.id_Evento, evento.arquivos]);

    // --------------------------------

    // Cadastro: a selfie é a do cliente
    useEffect(() => {
        if (tipoVistoria !== 'vistoria_cadastro') return;
        const lista = listaPesquisa.listaCliente[0];
        const arquivoSelf = (lista?.arquivos || []).filter(arquivo => arquivo.includes('selfie'));
        if (refazendoSelfie) return;
        setselfieArquivo(arquivoSelf.length > 0 ? arquivoSelf.pop() : '');
    }, [listaPesquisa.listaCliente, refazendoSelfie, tipoVistoria]);

    
    // --------------------------------

    const [CarregarTela, setCarregarTela] = useState(false);

    function FecharLoadBola() {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                loadBola: false,
            }
        });
    };
    // --------------------------------

    useEffect(() => {
        if ( parametroInit.DadosLocalizado || (!CarregarTela && (listaPesquisa.listaEvento.length > 0 || listaPesquisa.listaVeiculo.length > 0 ))) {     
            dispatch({
                type: 'SET_parametroInit',
                payload: {
                    ...parametroInit,
                    loadBola: true,
                }
            });

            setTimeout(() => {
                FecharLoadBola();
                if (dadosFipeRecebidos || listaPesquisa.listaVeiculo.length > 0) setCarregarTela(true);
                
            }, 1000);
        };
    }, [parametroInit.DadosLocalizado, CarregarTela, listaPesquisa.listaEvento, listaPesquisa.listaVeiculo]);
    // -------------------------

    const arquivosVeiculo = (listaPesquisa.listaVeiculo.find(v => v?._id === veiculo.id_Veiculo) || listaPesquisa.listaVeiculo[0])?.arquivos || [];

    useEffect(() => {
        if (tipoVistoria === 'vistoria_cadastro') return;
        setArqVistoria((evento.arquivos || []).filter(arquivo => arquivo.includes('vistorias')));
    }, [evento.arquivos, tipoVistoria]);

    // No cadastro, os arquivos da vistoria ficam no veículo
    useEffect(() => {
        if (tipoVistoria !== 'vistoria_cadastro') return;
        setArqVistoria(arquivosVeiculo.filter(arquivo => arquivo.includes('vistorias')));
    }, [listaPesquisa.listaVeiculo, tipoVistoria, veiculo.id_Veiculo]);
    // ------------------------------

    useEffect(() => {
        if (listaPesquisa.listaVeiculo.length === 0 && dadosFipeRecebidos && veiculo.tipo && ConfirmadoPlaca) {
            AddPlaca();
        }
    }, [dadosFipeRecebidos, veiculo.tipo, ConfirmadoPlaca]);
    // ---------------------------------

    
    

    //###################################################################################################
    return (
        <S.App fundoBloque = { condutorOutro || ModalCondutor}>
            <Header playLogo={true} />
            <div className='fundoBloque'/>
            <Load_Bola />

            {selfieParaDecisao && (
                <div style={{position:'fixed', inset:0, zIndex:30, display:'flex', alignItems:'center', justifyContent:'center', padding:'20px', backgroundColor:'rgba(0,0,0,0.8)'}}>
                    <div style={{display:'flex', flexDirection:'column', alignItems:'center', gap:'14px', width:'100%', maxWidth:'400px', padding:'20px', borderRadius:'12px', backgroundColor:'#0b0f14', color:'#fff', textAlign:'center'}}>
                        <strong style={{fontSize:'18px', color:'#00D594'}}>SELFIE JÁ CADASTRADA</strong>
                        <img
                            src={`${S3_BASE_URL}${selfieParaDecisao}`}
                            alt="Última selfie cadastrada do cliente"
                            style={{width:'100%', maxWidth:'300px', maxHeight:'45vh', objectFit:'contain', borderRadius:'10px', border:'2px solid #00D594'}}
                        />
                        <span>Esta é a última selfie cadastrada. Deseja refazer?</span>
                        <div style={{display:'flex', justifyContent:'center', flexWrap:'wrap', gap:'10px', width:'100%'}}>
                            <button
                                type="button"
                                onClick={() => {
                                    setselfieArquivo(selfieParaDecisao);
                                    setRefazendoSelfie(false);
                                    setSelfieParaDecisao('');
                                }}
                                style={{padding:'10px 16px', borderRadius:'6px', backgroundColor:'#00D594', color:'#0b0f14'}}
                            >
                                manter selfie
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    setselfieArquivo('');
                                    setRefazendoSelfie(true);
                                    setAbrirCameraRefazer(true);
                                    setSelfieParaDecisao('');
                                }}
                                style={{padding:'10px 16px', borderRadius:'6px', backgroundColor:'#2563eb', color:'#fff'}}
                            >
                                Sim, refazer
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* ---------------------------- */}
            <S.body CarregarTela={CarregarTela || !veiculo.placa}>
                
                <S.Inicio>
                    <div style={{display:"flex", width: "100%", gap:"10px", flexDirection:"column", alignItems:"center", borderBottom:"2px solid #00D594" }}>
                        <span 
                        style={{fontWeight:"bold", fontSize:"15px", paddingBottom:"10px"}} 
                        >
                            VISTORIA
                        </span>
                    </div>

                    {/* <Geolocalizacao /> */}

                    {(!veiculo.placa) &&
                    <S.containerPesq>
                        <PesquisaPlaca
                        titulo = "PLACA:"
                        setBuscandoDadosPlaca={setBuscandoDadosPlaca}
                        setSucessoBuscaPlaca={setSucessoBuscaPlaca}
                        setDadosDivergentes={setDadosDivergentes}
                        dadosCompletos={dadosCompletos}
                        buscandoDadosPlaca={buscandoDadosPlaca}
                        setdadosCompletos={setdadosCompletos}
                        setErroNumero={setErroNumero}
                        setSituacaoDivergente={setSituacaoDivergente}
                        setErroBuscaPlaca={setErroBuscaPlaca}
                        setValorFipeNumerico={setValorFipeNumerico}
                        maioresScoresFipe={maioresScoresFipe}
                        setmaioresScoresFipe={setmaioresScoresFipe}  
                        valorMensalCotac={valorMensalCotac}
                        valorFipeNumerico={valorFipeNumerico}
                        dadosFipeRecebidos={dadosFipeRecebidos}
                        setDadosFipeRecebidos={setDadosFipeRecebidos}
                        
                        />
                    </S.containerPesq>
                    }
                </S.Inicio>

                <S.VistoriaModal CarregarTela={CarregarTela } style={{alignItems:"center"}}>
                    {//---------MOSTRAR DADOS----------------------- 
                    mostrarDados &&
                    <S.Modal>
                        <ModalCotacao_PREVIEW 
                        fazerCotacao={true}
                        dadosCompletos={dadosCompletos} 
                        setdadosCompletos={setdadosCompletos}
                        erroBuscaPlaca={erroBuscaPlaca}
                        sucessoBuscaPlaca={sucessoBuscaPlaca}
                        dadosDivergentes={dadosDivergentes}
                        situacaoDivergente={situacaoDivergente}
                        maioresScoresFipe={maioresScoresFipe}
                        setValorFipeNumerico={setValorFipeNumerico}
                        buscandoDadosPlaca={buscandoDadosPlaca}
                        valorMensalCotac={valorMensalCotac}
                        setvalorMensal={setvalorMensal}
                        />

                        { /*---------Buttons CONFIRMAR VEICULO----------- */
                        veiculo.modelo &&
                        <div style={{display:"flex", justifyContent:"center", marginTop:"10px", gap:"10px"}}>
                            <button
                            style={{ display:"flex",alignItems:"center", cursor: "pointer", backgroundColor: "red", color: "black",  padding: '12px', fontWeight: "bold"}}
                            type='button'
                            onClick={() => {
                                EditarSelect("eventoPlaca");
                                setCarregarTela(false);
                                setmostrarDados(false);
                                setDadosFipeRecebidos(null);
                                SetParametroInit('DadosLocalizado', false);

                                }}>
                            X
                            </button>

                            <button
                            style={{ display:"flex",alignItems:"center", cursor: "pointer", backgroundColor: "#00FF00", color: "black",  padding: '12px', fontWeight: "bold"}}
                            type='button'
                            onClick={() => {
                                setConfirmarDados(true);
                                setmostrarDados(false);
                                }}>
                            CONFIRMAR
                            </button>
                        </div>
                        }
                    </S.Modal>
                    }

                    { //-----------------------------------------------
                    !abrirCamera && ConfirmadoPlaca &&
                    <>
                        {// ---------CABECALHO------------
                        cliente.id_Cliente &&
                        <S.box style={{alignItems:"center", justifyContent:"center", fontSize:"14px", width:"95vw", maxWidth:"450px"}}>
                            <div className='listaFlexCol' style={{alignItems:"center", justifyContent:"center", gap:"5px", fontSize:"clamp(13px, 1.5vw, 16px)"}}>
                                { cliente.cpfCnpj &&
                                    <div style={{fontWeight:"bold"}}>
                                        {cliente.nome}
                                    </div>
                                }
                                <div style={{display:"flex", gap:"10px"}}>
                                    <span> 
                                        {veiculo.modelo} - PLACA: {veiculo.placa}
                                    </span>
                                </div>
                            </div>
                        </S.box>
                        }

                        {/* --------EVENTO----------- */}

                        {evento.id_Evento &&
                        <S.box style={{display:"flex", flexDirection: "row", width: "100%", justifyContent:"space-around", fontSize:"clamp(12px, 1.5vw, 15px)"}}>
                            <div className='listaFlexRow'>
                                <span style={{color:"#00D594"}}>DATA EVENTO: </span>
                                <div className='intem'>
                                    { evento.dataEvento && format(new Date(evento.dataEvento), 'dd/MM/yyyy')}
                                </div>
                            </div>

                            <div className='listaFlexRow'>
                                <span style={{color:"#00D594"}}>CONDUTOR: </span>
                                <div className='intem'>
                                    { evento.nomeCondutor}
                                </div>
                            </div>
                        </S.box>
                        }

                         {/* ------------ ICONS ----------  */}
                        <S.IconBar>
                            <S.IconButton
                                type="button"
                                onClick={() => setActivePanel('dados')}
                                aria-pressed={activePanel === 'dados'}
                            >
                                <span className='icon'>🧾</span>
                                <span> {tipoVistoria === 'vistoria_cadastro' ? 'COTAÇÃO' : 'CONDUTOR'}</span>
                            </S.IconButton>

                            <S.IconButton
                                type="button"
                                onClick={() => {
                                    setActivePanel('selfie');
                                    if (!selfieArquivo && !selfieCapturada) {
                                        setMostrarCamera(true);
                                    } else {
                                        setMostrarCamera(false);
                                    }
                                }}
                                aria-pressed={activePanel === 'selfie'}
                            >
                                <span className='icon'>📸</span>
                                <span>Selfie</span>
                            </S.IconButton>

                            {tipoVistoria !== 'vistoria_cadastro' &&
                            <S.IconButton
                                type="button"
                                onClick={() => setActivePanel('narracao')}
                                disabled={!evento.id_Evento || !selfieArquivo}
                                aria-pressed={activePanel === 'narracao'}
                            >
                                <span className='icon'>📝</span>
                                <span>Narração</span>
                            </S.IconButton>}

                            <S.IconButton
                                type="button"
                                onClick={() => { setActivePanel('vistoria')}}
                                disabled={evento.id_Evento? !evento.narracao : !selfieArquivo}
                                aria-pressed={activePanel === 'vistoria'}
                            >
                                <span className='icon'>🚗</span>
                                <span>Vistoria</span>
                            </S.IconButton>
                            
                            <S.IconButton
                                type="button"
                                onClick={() => setActivePanel('painel_arquivos')}
                                disabled={!selfieArquivo}
                                aria-pressed={activePanel === 'painel_arquivos'}
                            >
                                <span className='icon'>🗂️</span>
                                <span>Arquivos</span>
                            </S.IconButton>
                        </S.IconBar>

                        {//---------LISTA EVENTOS PLACA----------------
                        listaPesquisa.listaEvento.length > 1 && 
                        <S.ModalConteine>
                            {loading && 
                            <S.bodyresult>
                                <LoadingContent />
                            </S.bodyresult>
                            }

                            <S.bodyColunas>
                                <ListaEventosPlaca
                                    titulo="Aberto"
                                    listaBusca={listaPesquisa.listaEvento}
                                    alertDelete={false}
                                    setAletDelete={()=>{}}
                                    newStatus={()=>{}}
                                    setNewStatus={()=>{}}
                                    setRefDelet={()=>{}}
                                    PesqEventoCod={()=>{}}
                                    SomaTotal={0}
                                />
                            </S.bodyColunas>                            
                        </S.ModalConteine>
                        }

                        { //---------TIPO VISTORIA-----CONDUTOR---------------
                        ((!evento.id_Condutor || !tipoVistoria || tipoVistoria === 'vistoria_cadastro') && activePanel === 'dados' && ModalCondutor) && 
                        <> 
                            <S.CondutorModalCard>
                                {!tipoVistoria && (
                                    <BotaoAlertVistoria
                                        tipoVistoria={tipoVistoria}
                                        onSelect={(tipo) => {
                                            setTipoVistoria(tipo);
                                            if (tipo === 'vistoria_evento') {
                                                // Busca no banco os eventos (arquivos e selfie) da placa
                                                PesqVistoriaPlaca(veiculo.placa);
                                                return;
                                            }
                                            const selfieExistente = buscarUltimaSelfieCliente();
                                            if (selfieExistente) {
                                                setSelfieParaDecisao(selfieExistente);
                                            }
                                        }}
                                    />
                                )}

                                {tipoVistoria === 'vistoria_evento' && (
                                    <BotaoAlertCodutor
                                        primeiroNome={primeiroNome}
                                        onAssociado={() => {
                                            setCondutorAssociado(true);
                                            
                                        }}
                                        onOutro={() => {
                                            setOutroCondutor(true);
                                            dispatch({ type: 'set_limparcliente'}); 
                                        }}
                                        onVoltar={() => {
                                            setOutroCondutor(false);
                                            setCondutorAssociado(false);
                                            setTipoVistoria('');
                                        }}
                                    />
                                )}
                            </S.CondutorModalCard>

                            {(condutorOutro || CondutorAssociado) && 
                            <div style={{zIndex:"6", position: 'fixed', top:"80px", left:0, right: 0, bottom:0}}>
                                <CondutorEvento
                                titulo="CONDUTOR DO EVENTO"
                                CondutorAssociado={CondutorAssociado}
                                setCarregarTela={setCarregarTela}
                                onOk={onOk}
                                setOnOk={setOnOk}
                                condutorOutro={condutorOutro}
                                tipoVistoria={tipoVistoria}

                                setOutroCondutor={setOutroCondutor}
                                setCondutorAssociado={setCondutorAssociado}
                                setTipoVistoria={setTipoVistoria}
                                setModalCondutor={setModalCondutor}
                                onConfirmarCadastro={() => setBoasVindas(true)}
                                />
                            </div>
                            }
                        </>
                        }

                        { // Boas vindas modal ------------
                        boasVindas &&
                        <div style={{position:'fixed', top:0, left:0, right:0, bottom:0, zIndex:20, display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div style={{background:'#2b2b2b', color:'#fff', padding:'32px', borderRadius:'12px', maxWidth:'420px', textAlign:'center'}}>
                                <h2>Olá {primeiroNome}, seja bem-vindo à Mais Apoio! 🎉</h2>
                                <p>Vamos seguir com a cotação da proteção do seu veículo.</p>
                                <button
                                    type="button"
                                    onClick={async () => {
                                        if (tipoVistoria === 'vistoria_cadastro') {
                                            dispatch({ type: 'SET_parametroInit', payload: { ...parametroInit, loadBola: true } });
                                            try {
                                                await AddCotacao();
                                            } finally {
                                                dispatch({ type: 'SET_parametroInit', payload: { ...parametroInit, loadBola: false } });
                                            }
                                        }
                                        setBoasVindas(false);
                                    }}
                                    style={{marginTop:'16px', padding:'10px 24px', border:'none', borderRadius:'6px', background:'#4CAF50', color:'#fff', cursor:'pointer'}}
                                >
                                    CONTINUAR
                                </button>
                            </div>
                        </div>
                        }

                        {tipoVistoria === 'vistoria_cadastro' && activePanel === 'dados' && veiculo.modelo && !boasVindas &&
                            <CotacaoResumo
                                veiculo={veiculo}
                                valorMensal={valorMensalCotac}
                                onConcordo={() => {
                                    setCotacaoAceita(true);
                                    setActivePanel('selfie');
                                    if (!selfieArquivo && !selfieCapturada) setMostrarCamera(true);
                                }}
                            />
                        }

                        { /* -------------CAMERA SELFIE ------------- */
                        <>
                        {mostrarCamera && 
                        <CameraSelfie
                        setMostrarCamera={setMostrarCamera}
                        setselfieCapturada={setselfieCapturada}
                        veiculoPlaca={veiculo.placa}
                        />}

                        {selfieCapturada &&
                            <>
                            <span style={{fontWeight:"bold", fontSize:"18px", color:"#00D594"}}>
                                SELFIE CAPTURADA
                            </span>
                            <img 
                                src={selfieCapturada} 
                                alt="Selfie Capturada" 
                                style={{
                                    width:"300px", 
                                    height:"auto", 
                                    borderRadius:"10px",
                                    border:"2px solid #00D594"
                                }}
                            />
                            <div style={{display:"flex", gap:"10px"}}>
                                <button
                                    style={{
                                        padding:"10px 20px",
                                        backgroundColor:"#10b981",
                                        color:"white",
                                        border:"none",
                                        borderRadius:"5px",
                                        cursor:"pointer",
                                        fontWeight:"bold"
                                    }}
                                    onClick={() => {
                                        setRefazendoSelfie(false);
                                        setConfirmarImagemSelfie(true);
                                    }}
                                >
                                    ✅ Confirmar
                                </button>
                                <button
                                    style={{
                                        padding:"10px 20px",
                                        backgroundColor:"#ef4444",
                                        color:"white",
                                        border:"none",
                                        borderRadius:"5px",
                                        cursor:"pointer",
                                        fontWeight:"bold"
                                    }}
                                    onClick={() => {
                                        setselfieCapturada(null);
                                        setMostrarCamera(true);
                                    }}
                                >
                                    🔄 Repetir
                                </button>
                            </div>
                            </>
                        }
                            
                        {activePanel === 'selfie' && selfieArquivo && (
                        <S.PanelCard>
                            {selfieArquivo && !mostrarCamera && !selfieCapturada && (
                            <>
                                <span style={{fontWeight:"bold", fontSize:"18px", color:"#00D594"}}>
                                    SELFIE SALVA
                                </span>
                                <img 
                                    src={`${S3_BASE_URL}${selfieArquivo}`} 
                                    alt="Selfie Salva" 
                                    style={{
                                        width:"300px", 
                                        height:"auto", 
                                        borderRadius:"10px",
                                        border:"2px solid #00D594"
                                    }}
                                />
                                <button
                                    style={{
                                        padding:"10px 20px",
                                        backgroundColor:"#2563eb",
                                        color:"white",
                                        border:"none",
                                        borderRadius:"5px",
                                        cursor:"pointer",
                                        fontWeight:"bold"
                                    }}
                                    onClick={() => setMostrarCamera(true)}
                                >
                                    🔄 Refazer Selfie
                                </button>
                            </>
                            )}

                            
                        </S.PanelCard>
                        )}
                        </>}
                        
                        { /* -----------NARRACAO--------- */
                        evento.id_Evento && selfieArquivo && activePanel === 'narracao' &&
                        <>
                        {!evento.narracao ?
                        <S.PanelCard>
                            <NarracaoEvento
                            narracaoDigitada={narracaoDigitada}
                            setNarracaoDigitada={setNarracaoDigitada}
                            />
                        </S.PanelCard>
                        :
                        // Mostra a narração existente
                        <S.PanelCard>
                            <span style={{fontWeight:"bold"}}>Narração do Evento:</span>
                        
                            <p style={{marginTop:"5px", fontSize:"14px", wordBreak: "break-word"}}>
                                {evento.narracao}
                            </p>
                        </S.PanelCard>
                        }
                        </>
                        }
                        
                    {// ------------------CAMERA VISTORIA / ARQUIVOS DO EVENTO---------------------- */}
                    ((evento.narracao || (tipoVistoria === 'vistoria_cadastro' && selfieArquivo)) && activePanel === 'vistoria') && 
                    (tipoVistoria === 'vistoria_evento' ?
                    <S.PanelCard>
                        <span style={{fontWeight:"bold", fontSize:"16px", color:"#00D594"}}>
                            ADICIONAR ARQUIVOS DA VISTORIA
                        </span>
                        <AddArquivos permitirExcluirArquivosSalvos={false} />
                        <div style={{display:"flex", gap:"10px", flexWrap:"wrap", justifyContent:"center"}}>
                            <button
                                type="button"
                                onClick={SelectFile}
                                style={{padding:"10px 20px", borderRadius:"5px", backgroundColor:"#2563eb", color:"white"}}
                            >
                                📎 Selecionar arquivos
                            </button>
                            <button
                                type="button"
                                disabled={!listaPesquisa.listaArquivos || listaPesquisa.listaArquivos.length === 0}
                                onClick={() => AtualizarIdEvento({ tipoFile: "vistorias" })}
                                style={{
                                    padding:"10px 20px", borderRadius:"5px", backgroundColor:"#10b981", color:"white",
                                    opacity: listaPesquisa.listaArquivos?.length ? 1 : 0.4
                                }}
                            >
                                ✅ Enviar
                            </button>
                        </div>
                    </S.PanelCard>
                    :
                    <CameraSinistro
                    ImgPosition={ImgPosition}
                    setarrayImgPosition={setarrayImgPosition}
                    placa={veiculo.placa}
                    setabrirCamera={setabrirCamera}
                    tipoVistoria={tipoVistoria}
                    />)
                    }

                    {/* ------------------ARQUIVOS---------------------- */}
                    {
                    activePanel === 'painel_arquivos' &&
                    <S.PanelCard>
                        <ExibirArquivosS3
                        arquivos={tipoVistoria === 'vistoria_cadastro' ? arquivosVeiculo : evento.arquivos}
                        />
                    </S.PanelCard>
                    }

                    </>
                    }
                </S.VistoriaModal>
            </S.body>
            <Footer />
        </S.App>
    )
}
export default Vistoria;
